import ENVIRONMENT_VARIABLES from './environmentVariables';

var generateRender = function generateRender(component) {
  return component[ENVIRONMENT_VARIABLES.APPLICATION_TARGET] || component['default'];
};

export default generateRender;